<div class="d-flex align-items-center justify-content-between mb-5">
    <h1 class="montserrat-light text-gray-500 text-capitalize">{{ title }}</h1>
    <!--  <div class="d-flex align-items-center">-->
    <!--    <a href="javascript:;" class="search rounded-circle bg-gray-500 mr-3">-->
    <!--      <img src="./assets/images/search.svg" alt="Search" title="Search" />-->
    <!--    </a>-->
    <!--    <a href="javascript:;" class="btn btn-lg btn-gray-500">-->
    <!--      save your progress-->
    <!--    </a>-->
    <!--  </div>-->
</div>
<!-- All disclaimers live at the top of the page, outside the progress-bar block, so they stay
     visible on every step and on pages that hide the step bar (e.g. checkout). -->
<div
    *ngIf="currCampaign?.disclaimerMessage"
    class="text-center alert alert-primary mt-4"
>
    {{ currCampaign.disclaimerMessage }}
</div>
<div
    *ngFor="let banner of currCampaign?.banners"
    class="campaign-banner text-center alert alert-primary mt-4"
>
    {{ banner.message }}
    <button
        type="button"
        class="campaign-banner__close"
        aria-label="Close"
        (click)="dismissBanner(banner)"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<ng-container *ngIf="showProgressBar">
    <div class="text-center mb-3">Start a new campaign in 5 steps !</div>
    <div class="progress-bar position-relative text-center mx-auto">
        <ul class="p-0 m-0 d-flex align-items-center justify-content-between">
            <li *ngFor="let step of steps">
                <button
                    (click)="navigateToUrl(step)"
                    [ngClass]="{
                        available: checkIfLinkActive(step)
                    }"
                >
                    {{ step.step }}
                </button>
            </li>
        </ul>
    </div>
    <div
        *ngIf="this.previewMode && !editMode && !partialEditMode"
        class="text-center alert alert-primary mt-4"
    >
        You are in preview mode, any changes performed won't be saved.
    </div>
</ng-container>
